import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeatureGroupResponseModel, featureResponseModel, userModuleFeatureResponseModel } from '../models/response/feature-group-response';
import { Result, ResultOfT } from '../models/response/result';
import { SettingsResponseModel } from '../models/response/appointment/settings-response';
import { BaseService } from './base.service';
import { WebStorageService } from '../services/web-storage.service';
import { WipStatus, WipStatusBTmapping } from 'src/app/shared/models/common/wip-status';
import { SettingsPluginResponseModel, RCMCofigurationUrl } from 'src/app/shared/models/response/settings/settings-plugin-response-model';
import { of } from 'rxjs';
import { JwtPayload } from '../models/common/jwt-payload.interface';
import { jwtDecode } from 'jwt-decode';
@Injectable({
  providedIn: 'root'
})
export class FeatureGroupService extends BaseService {
  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }

  getFeatureGroup() {
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      return this.get<ResultOfT<FeatureGroupResponseModel[]>>('Roles/GetFeatureGroup/' + currentUserToken.roleId);
    }
  }
  getPermission() {
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    const tokenRoleId = this.getUserRoleId(currentUserAuthToken.token);
    if (currentUserToken && currentUserAuthToken.token) {
      return this.get<ResultOfT<featureResponseModel[]>>('Roles/GetPermission?roleId=' + tokenRoleId);
    }
  }

  getUserPermission() {
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      return this.get<ResultOfT<userModuleFeatureResponseModel[]>>('Roles/GetUserPermission');
    }
  }

  getSettings(settingsKey: string) {
    return this.get<ResultOfT<SettingsResponseModel>>('Settings/GetSettingByKey?SettingKey=' + settingsKey);
  }

  GetRCMConfigurationUrl(appPluginId: string) {
    return this.get<ResultOfT<RCMCofigurationUrl>>('RCMProvider/GetRCMConfigurationUrl/' + appPluginId);
  }

  logout() {
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    if (currentUserToken) {
      this.webStorageService.deleteCurrentUserToken();
      return this.get<Result>(`Users/Logout/${currentUserToken.userId}`);
    }
    return of(null);
  }

  decodeToken(token: string): JwtPayload | null {
    try {
      // Remove 'Bearer ' prefix if present
      const cleanToken = token.replace(/^Bearer\s+/, '');
      // Decode the token
      const decoded = jwtDecode<JwtPayload>(cleanToken);
      return decoded;
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
  }
  getClaim(token: string, claimName: string): string | number | null {
    try {
      const decoded = this.decodeToken(token);
      return decoded ? decoded[claimName] : null;
    } catch (error) {
      console.error('Error getting claim from token:', error);
      return null;
    }
  }
  getUserRoleId(token: string): string | null {
    const userRoleId = this.getClaim(token, 'UserRoleId') as string;
    if (userRoleId == '' || userRoleId == undefined || userRoleId == null) {
      return this.getClaim(token, 'user-role-id') as string;
    } else return userRoleId;
  }
}
